import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CarnetEntry } from '@app/models/carnet-liaison';

@Injectable({
  providedIn: 'root'
})
export class CarnetLiaisonService {

  constructor(private http: HttpClient) { }

  getEntry(idEnfant: number, date: string): Observable<CarnetEntry | null> {
    return this.http
      .get<CarnetEntry>(`/enfants/${idEnfant}/carnet-liaison?date=${date}`)
      .pipe(catchError(() => of(null)));
  }
}
